export const GET_AVAILABLE_LANGUAGES_QUERY_KEY =
  'home/useGetAvailableLanguages';
